import React from 'react';
import { CustomerStateBadge } from '../../../customers/components/CustomerStateBadge';
import type { CustomerState } from '../../../customer-states/types/customer-states.types';

interface CustomerStateDisplayProps {
    allStates: CustomerState[];
    isFetching: boolean;
    selectedContact: any;
    onStateClick?: () => void;
}

export const CustomerStateDisplay: React.FC<CustomerStateDisplayProps> = ({
    allStates,
    isFetching,
    selectedContact,
    onStateClick,
}) => {
    const currentState = allStates.find(
        s => s.id === selectedContact?.customer?.currentStateId
    );

    // Mobile: Show compact badge if currentState exists in customer object
    if (selectedContact?.customer?.currentState) {
        return (
            <CustomerStateBadge
                state={selectedContact.customer.currentState}
                compact
                className="d-lg-none"
                onClick={onStateClick}
            />
        );
    }

    // Mobile: Show badge from allStates if found
    if (currentState) {
        return (
            <span className="d-lg-none ms-1 d-flex align-items-center">
                <CustomerStateBadge state={currentState} />
            </span>
        );
    }

    // Mobile: Show loading spinner if fetching and currentStateId exists
    if (selectedContact?.customer?.currentStateId && isFetching) {
        return (
            <span className="d-lg-none ms-1 d-flex align-items-center" style={{ height: '24px' }}>
                <div
                    className="spinner-border spinner-border-sm text-secondary opacity-75 me-1"
                    role="status"
                    style={{ width: '0.85rem', height: '0.85rem' }}
                />
                <span className="text-muted fs-12">Cargando...</span>
            </span>
        );
    }

    return null;
};
